export default "__VITE_ASSET__yQcsMvad__"